import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ProjectName from './project-name';

function Option(props) {
  return (
    <MenuItem
      ref={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        paddingLeft: 15,
        display: 'flex',
        flexWrap: 'wrap',
        whiteSpace: 'normal'
      }}
      {...props.innerProps}
    >
      <span>
        {props.children}
      </span>
      {props.selectProps.showProjectName ?
        <ProjectName project={props.data?.project} /> : null}
    </MenuItem>
  );
}

export default Option;
